import React, { useState } from "react";
import styled from 'styled-components';
import ConnectWalletPopup from "./ConnectWalletPopup";
// import {
//   init
// } from "../config/provider";

const Root = styled.div`
 display:flex;
 justify-content:space-between;
 padding:${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.none};
 @media(max-width:768px){
    padding: 0;
}
 @media(max-width:1024px){
    padding: 0;
}
`;
const Title = styled.div`
font-family: SweraDemo;
font-size: 36px;
@media(max-width:768px){
    font-size:24px;
    padding-bottom: 0;
}
@media(max-width:1024px){
    font-size:24px;
    padding-bottom: 0;
}
`;

const HeaderComponents = ({title}) =>{
    const [showPopup,setShowPopup] = useState(false);
    
    return(
        <Root>   
             <Title>{title}</Title>
             {/* <Button 
            //    onClick={() =>setShowPopup(!showPopup) } 
               onClick={connect} 
               radius="xl" 
               bdcolor="yellow" 
               top="xs" 
               bottom="xs"
               left="sm" 
               right="sm" 
               color="yellow">
                   Connect Wallet
            </Button> */}
             {showPopup && 
             <ConnectWalletPopup 
                showPopup={showPopup} 
                setShowPopup={setShowPopup}>
            </ConnectWalletPopup>}
        </Root>
    );
};

export default HeaderComponents;